<template>
  <el-dialog
    title="SimFlightReport"
    :close-on-click-modal="false"
    :visible.sync="dialogVisiable"
    :append-to-body="true"
    @close="hide"
    custom-class="routePlanningReportContainer"
    width="676px"
  >
    <div class="dataContainer">
      <div class="separator"></div>
      <label class="reportTitle">推演报告</label>
      <div class="reportInfoContainer">
        <div class="rows localIdRow">
          <div class="title">编号：</div>
          <div class="no">{{ local_id }}</div>
        </div>
        <div class="rows">
          <div class="descTitle">创建时间：</div>
          <div class="desc">{{ createTime }}</div>
          <div class="descTitle">航线长度：</div>
          <div class="desc">{{ totalLength }}KM</div>
          <div class="descTitle">起点：</div>
          <div class="content">{{ starStayPointName }}</div>
          <div class="descTitle">终点：</div>
          <div class="content">{{ endStayPointName }}</div>
        </div>
      </div>
      <el-table
        ref="routeList"
        :data="routeList"
        height="200"
        style="width: 635px"
        :row-style="{ height: '40px' }"
        :cell-style="{ padding: '0' }"
        :row-class-name="tableRowClassName"
        tooltip-effect="light"
        class="taskTable"
      >
        <el-table-column
          prop="local_id"
          label="航点"
          align="center"
          min-width="85"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="lon"
          label="经度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="lat"
          label="纬度"
          align="center"
          min-width="75"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="rAlt"
          label="绝对飞行高度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="alt"
          label="相对飞行高度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="command"
          label="附加指令"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script type="text/javascript">
export default {
  name: "RoutePlanningReport",
  data() {
    return { dialogVisiable: false };
  },
  props: [
    "local_id",
    "createTime",
    "routeList",
    "showModifyReport",
    "totalLength",
    "starStayPointName",
    "endStayPointName",
  ],
  methods: {
    hide() {
      this.$emit("changeModifyReportStatus", false);
    },
    tableRowClassName({ row, rowIndex }) {
      return "rowStyle";
    },
  },
  watch: {
    showModifyReport: function (nval, oval) {
      if (nval) {
        this.$data.dialogVisiable = true;
      } else {
        this.$data.dialogVisiable = false;
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/routePlanningReport.css";
</style>
<style>
.routePlanningReportContainer .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px !important;
}

.routePlanningReportContainer .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}

.routePlanningReportContainer .el-table__body-wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}
.routePlanningReportContainer {
  width: 676px;
  background: rgba(28, 35, 64, 0.9);
  border: 1px solid #0083fd;
  border-radius: 6px;
}
.routePlanningReportContainer .el-dialog__header {
  height: 17px;
  padding: 24px 0px 14px 21px;
}
.routePlanningReportContainer .el-dialog__header .el-dialog__title {
  font-size: 18px;
  font-family: ArialMT;
  font-weight: 400;
  color: #ffffff;
  line-height: 16px;
  float: left;
}
.routePlanningReportContainer .el-dialog__header .el-icon-close {
  color: #ffffff;
}
.routePlanningReportContainer .el-dialog__header .el-icon-close:hover {
  color: #0083fd;
}
.routePlanningReportContainer .el-dialog__body {
  padding-top: 0px;
}

.routePlanningReportContainer .taskTable.el-table::before {
  height: 0px !important;
}

.routePlanningReportContainer .taskTable .el-table__body .rowStyle:hover > td {
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningReport.vue